import { SearchFields, DebtorSearchValueType} from "us.common/components/SelectDebtor/Components/Constants";

export function DebtorSearch(this: any) {
  return {
    SearchValue: this.firstSearchValue,
    SecValue: this.otherSearchValues.join(' AND '),
    Suggest: this.isNumeric ? DebtorSearchValueType.NUMBER : DebtorSearchValueType.TEXT,
    FieldType: this.fieldType,
    SearchEntityState: SearchFields.ALL_ENTITY,
    Hit: 1,
  };
}
